"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ContactPoint = exports.ContactPointUseKind = exports.ContactPointSystemKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_positiveInt_1 = require("../Scalar/RTTI_positiveInt");
var RTTI_Period_1 = require("./RTTI_Period");
var ContactPointSystemKind;
(function (ContactPointSystemKind) {
    ContactPointSystemKind["_phone"] = "phone";
    ContactPointSystemKind["_fax"] = "fax";
    ContactPointSystemKind["_email"] = "email";
    ContactPointSystemKind["_pager"] = "pager";
    ContactPointSystemKind["_url"] = "url";
    ContactPointSystemKind["_sms"] = "sms";
    ContactPointSystemKind["_other"] = "other";
})(ContactPointSystemKind = exports.ContactPointSystemKind || (exports.ContactPointSystemKind = {}));
var ContactPointUseKind;
(function (ContactPointUseKind) {
    ContactPointUseKind["_home"] = "home";
    ContactPointUseKind["_work"] = "work";
    ContactPointUseKind["_temp"] = "temp";
    ContactPointUseKind["_old"] = "old";
    ContactPointUseKind["_mobile"] = "mobile";
})(ContactPointUseKind = exports.ContactPointUseKind || (exports.ContactPointUseKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_ContactPoint = t.recursion('IContactPoint', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        system: (0, EnumType_1.createEnumType)(ContactPointSystemKind, 'ContactPointSystemKind'),
        _system: RTTI_Element_1.RTTI_Element,
        value: t.string,
        _value: RTTI_Element_1.RTTI_Element,
        use: (0, EnumType_1.createEnumType)(ContactPointUseKind, 'ContactPointUseKind'),
        _use: RTTI_Element_1.RTTI_Element,
        rank: RTTI_positiveInt_1.RTTI_positiveInt,
        _rank: RTTI_Element_1.RTTI_Element,
        period: RTTI_Period_1.RTTI_Period
    });
});
//# sourceMappingURL=RTTI_ContactPoint.js.map